import { computed, ref } from "vue";
import { defineStore } from "pinia";

export const useNetworkStore = defineStore("network", () => {
  // State
  const _connected = ref<boolean>(true);

  // Getters
  const connected = computed(() => _connected.value);

  // Actions
  const setConnected = (isConnected: boolean) => {
    _connected.value = isConnected;
  };

  return {
    connected,
    setConnected,
  };
});
